import { intercalcate } from "@/util/array-utils";
import cn from "@/util/cn";
import Link from "./Link";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "./chadcn/Breadcrumb";

type BreadcrumbsProps = {
  breadcrumbs: { title: string; href?: string }[];
  className?: string;
};

const Breadcrumbs = ({ breadcrumbs, className }: BreadcrumbsProps) => (
  <Breadcrumb className={className}>
    <BreadcrumbList>
      {intercalcate(
        breadcrumbs.map(({ title, href }, index) => (
          <BreadcrumbItem key={href ?? "last"}>
            <Link
              to={href ?? ""}
              className={cn(
                "text-base font-normal",
                index === breadcrumbs.length - 1 ? "text-primary/90" : "text-primary/60",
                href === undefined && "pointer-events-none cursor-default"
              )}
            >
              {title}
            </Link>
          </BreadcrumbItem>
        )),
        (index) => (
          <BreadcrumbSeparator className="h-4" key={`separator-${index}`}>
            <span className={cn("material-icons text-primary/60")} style={{ fontSize: "16px" }}>
              arrow_forward_ios
            </span>
          </BreadcrumbSeparator>
        )
      )}
    </BreadcrumbList>
  </Breadcrumb>
);

export default Breadcrumbs;
